module.exports = __webpack_public_path__ + "img/the-university-of-chicago-press-logo.52ca8c20.png";